// BestMate brand values used by the business websites' footers, in one place.
// Source of truth is @bestmate/brand (tango-landing/brand); this app doesn't depend on that package yet,
// so keep these in step with it.
// Footer links are real <a href> links (not onClick handlers) so search engines can follow them;
// the anchor text stays the brand name ("Powered by BestMate"), never keywords.
export const BRAND = {
    name: 'BestMate',
    url: 'https://gobestmate.com',
    terms: 'https://gobestmate.com/terms',
    privacy: 'https://gobestmate.com/privacy',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.bestmate.pro',
    appStore: 'https://apps.apple.com/us/app/bestmate-service-business-app/id1626461580',
};

// the link back from a business's website, tagged so sign-ups from it show up in analytics
export const poweredByUrl = (subdomain) =>
    `${BRAND.url}/?utm_source=business-website&utm_medium=footer&utm_campaign=powered-by${subdomain ? `&utm_content=${encodeURIComponent(subdomain)}` : ''}`;
